// @ts-nocheck
import { useTranslation } from "react-i18next";
import { Dropdown, Input, message, Select, Space } from "antd";
import { useNavigate } from "react-router-dom";
import { getText } from "../../../../utils/util";
// import "./index.css";
import { useEffect, useState } from "react";

export default function C2CCK({
  currencylist,
  num,
  setNum,
  currencyId,
  setcurrencyId,
  bankType,
  setbankType,
}) {
  const navigate = useNavigate();
  const { t: translate } = useTranslation();
  const lan = localStorage.getItem("i18n");
  const [currency, setcurrency] = useState({} as any);
  const getArray = () => {
    const array = [];
    let i = 0;
    for (const currency of currencylist) {
      array.push({
        value: currency.id,
        label: lan == "zh" ? currency.name : currency.currency,
      });
    }
    return array;
  };

  const bankTypeArray = [
    {
      value: 1,
      label: "Visa, Mastercard and JCB",
    },
    {
      value: 4,
      label: "Bank Card",
    },
    {
      value: 2,
      label: "Revolut",
    },
    {
      value: 3,
      label: "Wise",
    },{
      value: 5,
      label: "Remitly",
    },
  ];

  useEffect(() => {
    for (const currency of currencylist) {
      if (currency.id == currencyId) {
        setcurrency(currency);
      }
    }
  }, [currencyId]);

  return (
    <div className="flex flex-col space-y-5 text-neutral-100 revert-style">
      {/* 货币选择 */}
      <Select
        value={currencyId}
        className="custom-select dark-select currency-select h-12"
        placeholder={translate(getText("请选择货币"))}
        options={getArray()}
        dropdownClassName="custom-dropdown"
        onChange={(val) => {
          setcurrencyId(val);
          for (const currency of currencylist) {
            if (currency.id == val) {
              setcurrency(currency);
            }
          }
        }}
      />
      
      {/* 银行卡类型选择 */}
      <Select
        className="custom-select dark-select bank-select h-12"
        placeholder={translate(getText("请选择银行卡类型"))}
        options={bankTypeArray}
        dropdownClassName="custom-dropdown"
        onChange={(val) => {
          setbankType(val);
        }}
      />
      
      {/* 交易金额区域 */}
      <div className="mt-3">
        <div className="flex justify-between items-center text-neutral-300 text-sm mb-1 px-1">
          <span>{translate(getText("交易金额"))}</span>
        </div>
        
        <div className="bg-neutral-700 rounded-md overflow-hidden">
          <div className="flex items-center justify-between">
            <input
              type="text"
              placeholder="0.00"
              className="h-12 bg-transparent border-none outline-none w-full px-3 text-white"
              value={num}
              onChange={(e) => {
                setNum(e.target.value);
              }}
            />
            <div className="text-indigo-400 font-medium px-3">
              {currency?.currency || "USD"}
            </div>
          </div>
        </div>
      </div>
      
      {/* 兑换金额区域 */}
      <div className="mt-2">
        <div className="flex justify-between items-center px-1 mb-1">
          <span className="text-neutral-300 text-sm">{translate(getText("兑换金额"))}</span>
          <img src="/c2cck/change.png" className="w-5 h-5" />
        </div>
        
        <div className="bg-neutral-700 rounded-md overflow-hidden">
          <div className="flex items-center justify-between">
            <input
              disabled
              type="text"
              placeholder="0.00"
              className="h-12 bg-transparent border-none outline-none w-full px-3 text-neutral-300"
              value={num && currency?.rate && (num / currency?.rate).toFixed(2)}
            />
            <div className="text-indigo-400 font-medium px-3">
              USDT
            </div>
          </div>
        </div>
      </div>
      
      {/* 说明文字 */}
      <div className="mt-5 text-xs text-neutral-400 p-3 bg-neutral-800 rounded-md">
        {translate(
          getText(
            "您的C2C交易由系統自動匹配商家，法幣兌換數字貨幣是按照國際實時匯率進行交易。匹配到商家後，請必須注意備註信息內的收款銀行的必要信息以及標註信息的題目，並且請在規定時間內完成交易，如果超時完成造成的損失由您自行承擔"
          )
        )}
      </div>
      
      {/* 提示文字 */}
      <div className="text-xs text-indigo-400 font-medium mt-1">
        {translate(
          getText(
            "請先選擇貨幣，點擊確定表明您已經同意並且閱讀上方提示信息，否則請點取消"
          )
        )}
      </div>
    </div>
  );
}
